// Angular Modules
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { BhaktFormList, CommonAPIResponse } from 'src/app/classes/ApiModels';
import {
  FormDetail,
  EditFormDetail,
  AddQuestionDetail,
  Question,
  KutumbMember,
  spotRegisterData,
  pastPaymet,
} from 'src/app/from';
import { environment } from 'src/environments/environment';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { DatastoreService } from '../datastore.service';
import { EventDetails } from 'src/app/mycomponents/bhajanyag/ApiModels';

/** Response row from `Bhakt/CityVillageList` for present city/village autocomplete. */
export interface PresentVillageSearchItem {
  SubZoneId: number;
  CityVillageName: string;
  CityNameEng: string;
  CityNameGuj: string;
}

@Injectable({
  providedIn: 'root',
})
export class ApiHttpService {
  constructor(
    // Angular Modules
    private http: HttpClient,
    private dataService: DatastoreService
  ) {}

  headers = new HttpHeaders()
    .set('Access-Control-Allow-Origin', '*')
    .set('Access-Control-Allow-Credentials', 'true');
  public handleCommonResponse(result: CommonAPIResponse): any {
    return result.Data;
  }
  public createForm(data: FormDetail) {
    return this.http.post<CommonAPIResponse<any>>(
      `${environment.apiUrl}/PreRegistration/CreateForm`,
      data,
      { headers: this.headers }
    );
  }
  public updateForm(data: EditFormDetail) {
    this.dataService.formEdited.push(data.Id);
    return this.http.post<CommonAPIResponse<any>>(
      `${environment.apiUrl}/PreRegistration/EditForm`,
      data,
      { headers: this.headers }
    );
  }
  public addQuestion(data: Question) {
    this.dataService.formEdited.push(data.FormId);
    return this.http.post<CommonAPIResponse<any>>(
      `${environment.apiUrl}/PreRegistration/AddQuestion`,
      data,
      { headers: this.headers }
    );
  }
  public editQuestion(data: any) {
    this.dataService.formEdited.push(data.FormId);
    return this.http.post<CommonAPIResponse<any>>(
      `${environment.apiUrl}/PreRegistration/EditQuestion`,
      data,
      { headers: this.headers }
    );
  }
  public changeQuestionSequence(data: any[]) {
    return this.http.post<CommonAPIResponse<any>>(
      `${environment.apiUrl}/PreRegistration/ChangeQuestionSequence`,
      data,
      { headers: this.headers }
    );
  }
  public SaveFormInstruction(data: any) {
    return this.http.post<CommonAPIResponse<any>>(
      `${environment.apiUrl}/PreRegistration/SaveFormInstruction`,
      data,
      { headers: this.headers }
    );
  }
  public SaveFormBanner(data: any) {
    return this.http.post<CommonAPIResponse<any>>(
      `${environment.apiUrl}/PreRegistration/SaveFormBanner`,
      data,
      { headers: this.headers }
    );
  }
  public GetFormInformation(data: any) {
    return this.http.get<CommonAPIResponse<any>>(
      `${environment.apiUrl}/PreRegistration/GetFormInformation?FormId=${data}`,
      { headers: this.headers }
    );
  }

  public SyncGoogleSheetDataManually(formId: number) {
    return this.http.post<CommonAPIResponse<any>>(
      `${environment.apiUrl}/PreRegistration/SyncGoogleSheetDataManually?formId=${formId}`,
      {},
      { headers: this.headers }
    );
  }

  public DuplicateForm(formId: number) {
    return this.http.get<CommonAPIResponse<any>>(
      `${environment.apiUrl}/PreRegistration/DuplicateForm?FormId=${formId}`,
      { headers: this.headers }
    );
  }

  public get(url: string, options?: any) {
    return this.http.get(url, options);
  }
  public post(url: string, data: any, options?: any) {
    return this.http.post(url, data, options);
  }
  public put(url: string, data: any, options?: any) {
    return this.http.put(url, data, options);
  }
  public delete(url: string, options?: any) {
    return this.http.delete(url, options);
  }
  public GetBhaktFormList(deptId: number, FormId?: string) {
    let url = `${environment.apiUrl}/PreRegistration/GetBhaktFormList?DepartmentId=${deptId}`;
    if (FormId) {
      url = url + `&FormId=${FormId}`;
    }
    return this.http.get<CommonAPIResponse<any>>(url, {
      headers: this.headers,
    });
  }
  public AdminFormList(data: BhaktFormList) {
    return this.http.post<CommonAPIResponse<any>>(
      `${environment.apiUrl}/PreRegistration/GetFormList`,
      data,
      { headers: this.headers }
    );
  }
  public getformQuestion(FormId: number) {
    return this.http.get<CommonAPIResponse<any>>(
      `${environment.apiUrl}/PreRegistration/GetQuestionList?FormId=${FormId}`,
      { responseType: 'json' }
    );
  }

  /**
   * Form types: department users always get their dept mapping.
   * Super admin: omit or pass non-positive for all types; pass departmentId > 0 for that dept's mapping.
   */
  public getFormTypes(forDepartmentId?: number | null) {
    let url = `${environment.apiUrl}/PreRegistration/GetFormTypes`;
    if (forDepartmentId != null && forDepartmentId > 0) {
      url += `?departmentId=${forDepartmentId}`;
    }
    return this.http.get<CommonAPIResponse<any>>(url, { responseType: 'json' });
  }

  /** Super admin: all departments; department user: own department only */
  public getDepartments() {
    return this.http.get<CommonAPIResponse<any>>(
      `${environment.apiUrl}/PreRegistration/GetDepartments`,
      { responseType: 'json' }
    );
  }

  public getQuestionTypes() {
    return this.http.get<CommonAPIResponse<any>>(
      `${environment.apiUrl}/PreRegistration/GetQuestionTypes`,
      { responseType: 'json' }
    );
  }

  public getBhaktYtdAmount(bhaktGUID) {
    return this.http.get<CommonAPIResponse<any>>(
      `${environment.apiUrl}/Transaction/GetYearToDateDonations?bhaktGuid=${bhaktGUID}`,
      { responseType: 'json' }
    );
  }

  public getPanDetail(bhaktGUID, bhaktId) {
    return this.http.get<CommonAPIResponse<any>>(
      `${environment.apiUrl}/Bhakt/GetPANNumber?bhaktGuid=${bhaktGUID}&bhaktId=${bhaktId}`,
      { responseType: 'json' }
    );
  }

  public setPanDetail(bhaktGUID, bhaktId, pancard: string) {
    return this.http.put<CommonAPIResponse<any>>(
      `${environment.apiUrl}/Bhakt/AddPANNumber?bhaktGuid=${bhaktGUID}&bhaktId=${bhaktId}&PanNumber=${pancard}`,
      { responseType: 'json' }
    );
  }

  public submitFormResponse(data: any) {
    return this.http.post<CommonAPIResponse<any>>(
      `${environment.apiUrl}/PreRegistration/SaveFormResponses`,
      data,
      { headers: this.headers }
    );
  }

  public saveYagnaFormResponses(data: any) {
    return this.http.post<CommonAPIResponse<any>>(
      `${environment.apiUrl}/PreRegistration/SaveYagnaFormResponses`,
      data,
      { headers: this.headers }
    );
  }

  public getFormResponse(data: any) {
    return this.http.post<CommonAPIResponse<any>>(
      `${environment.apiUrl}/PreRegistration/GetResponseDetailsByForm`,
      data,
      { headers: this.headers }
    );
  }

  // Prefill: Get details of filled form for multiple BhaktIds
  public getFamilyFilledFormDetail(FormId: number, BhaktIds: number[]) {
    const body = { FormId, BhaktIds };
    return this.http.post<CommonAPIResponse<any>>(
      `${environment.apiUrl}/PreRegistration/GetFamilyFilledFormDetail`,
      body,
      { headers: this.headers }
    );
  }
  public GetUserFilledFormDetail(FormId: any, BhaktId: any) {
    return this.http.get<CommonAPIResponse<any>>(
      `${environment.apiUrl}/PreRegistration/GetUserFilledFormDetail?FormId=${FormId}&BhaktId=${BhaktId}`,
      { headers: this.headers }
    );
  }

  public deleteFormById(FormId: any) {
    return this.http.post<CommonAPIResponse<any>>(
      `${environment.apiUrl}/PreRegistration/DeleteForm?FormId=${FormId}`,
      { headers: this.headers }
    );
  }

  public deleteUserResponse(ResponseId: number, hardDelete: boolean = false) {
    return this.http.delete<CommonAPIResponse<any>>(
      `${environment.apiUrl}/PreRegistration/DeleteFormResponseByResponseId?ResponseId=${ResponseId}&hardDelete=${hardDelete}`,
      { headers: this.headers }
    );
  }

  public deleteMultipleUserResponses(ResponseIds: number[], hardDelete: boolean = false) {
    return this.http.delete<CommonAPIResponse<any>>(
      `${environment.apiUrl}/PreRegistration/DeleteFormResponseByResponseIds?hardDelete=${hardDelete}`,
      { headers: this.headers, body: ResponseIds }
    );
  }

  public DeleteYagnaFormResponseByResponseId(ResponseId: number, hardDelete: boolean = false) {
    return this.http.delete<CommonAPIResponse<any>>(
      `${environment.apiUrl}/PreRegistration/DeleteYagnaFormResponseByResponseId?ResponseId=${ResponseId}&hardDelete=${hardDelete}`,
      { headers: this.headers }
    );
  }

  public deleteQuestionById(id: number) {
    return this.http.post<CommonAPIResponse<any>>(
      `${environment.apiUrl}/PreRegistration/DeleteQuestion`,
      { questionId: id },
      { headers: this.headers }
    );
  }

  public GetBhaktDetailByBhaktId(BhaktId: any) {
    return this.http.get<CommonAPIResponse<any>>(
      `${environment.apiUrl}/Bhakt/GetBhaktDetail?BhaktId=${BhaktId}`,
      { headers: this.headers }
    );
  }

  public login(username: string, password: string) {
    let reqObj = {
      UserName: username,
      Password: password,
    };
    return this.http.post<CommonAPIResponse<any>>(
      `${environment.apiUrl}/Authenticate/Login`,
      reqObj,
      { headers: this.headers }
    );
  }

  public getSmkStatus() {
    return this.http.get<CommonAPIResponse<any>>(
      `${environment.apiUrl}/Bhakt/GetSmkStatus`,
      { headers: this.headers }
    );
  }

  public GetBhaktPrefilledConfig() {
    return this.http.get<CommonAPIResponse<any>>(
      `${environment.apiUrl}/PreRegistration/GetBhaktPrefilledConfigurations`,
      { headers: this.headers }
    );
  }

  public getKutumbMembers(BhaktGUID: string, FormId: number) {
    const url = `${environment.apiUrl}/Bhakt/KutumbMembers?bhaktGuid=${BhaktGUID}&formId=${encodeURIComponent(FormId)}`;
    return this.http.get<KutumbMember[]>(url, { headers: this.headers });
  }

  public spotRegisterBhakt(data: spotRegisterData) {
    return this.http.post<CommonAPIResponse<any>>(
      `${environment.apiUrl}/Bhakt/SpotRegistration`,
      data,
      { headers: this.headers }
    );
  }

  public updateSpotRegistrationDetails(data: spotRegisterData) {
    return this.http.put<CommonAPIResponse<any>>(
      `${environment.apiUrl}/Bhakt/UpdateSpotRegistrationDetails`,
      data,
      { headers: this.headers }
    );
  }

  public getPastPayments(BhaktGUID: string, startDate: any, endDate: any) {
    return this.http.get<CommonAPIResponse<any>>(
      `${
        environment.apiUrl
      }/Transaction/PastTransaction/Bhakt?bhaktGuid=${BhaktGUID}&startDate=${encodeURIComponent(
        startDate
      )}&endDate=${encodeURIComponent(endDate)}`,
      { headers: this.headers }
    );
  }

  /**
   * Prasad vitran pavti rows ([Forms].[SearchPavtiForPrasadVitran]).
   * One BhaktId is enough: proc returns the full kutumb/family set.
   */
  public searchPavtiPrasadVitran(bhaktId: number): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/PrasadVitran/SearchPavti?BhaktId=${bhaktId}`,
      { headers: this.headers }
    );
  }

  public GetTotalPendingPrasadQauntityByBhakt(bhaktId: number) {
    return this.http.get<CommonAPIResponse<any>>(
      `${environment.apiUrl}/PrasadVitran/GetTotalPendingPrasadQauntityByBhakt?BhaktId=${bhaktId}`,
      { headers: this.headers }
    );
  }

  public getPastPaymentsAdmin(startDate: any, endDate: any) {
    return this.http.get<CommonAPIResponse<any>>(
      `${
        environment.apiUrl
      }/Transaction/PastTransaction/AccountDept?startDate=${encodeURIComponent(
        startDate
      )}&endDate=${encodeURIComponent(endDate)}`,
      { headers: this.headers }
    );
  }

  // for directly hitting payment backend
  // `https://93mdmf55j8.execute-api.ap-south-1.amazonaws.com/Stage/payment/initiate`,

  public initiatePayment(data: any) {
    return this.http.post<any>(
      `${environment.apiUrl}/Transaction/Payment/Initiate`,
      data
    );
  }

  public getChandanReport(date: any) {
    return this.http.get<any>(
      `${
        environment.apiUrl
      }/Transaction/PastTransaction/AccountDept/ChandanVagha?vaghaDate=${encodeURIComponent(
        date
      )}`
    );
  }

  public payLater(data: any) {
    return this.http.post<CommonAPIResponse>(
      `${environment.apiUrl}/Transaction/Payment/PayLater`,
      data
    );
  }

  public getQuestionRules(FormId: number) {
    return this.http.get<CommonAPIResponse<any>>(
      `${environment.apiUrl}/PreRegistration/GetQuestionRules?FormId=${FormId}`,
      { responseType: 'json' }
    );
  }

  public addQuestionRule(data: any) {
    this.dataService.formEdited.push(data.FormId);
    return this.http.post<CommonAPIResponse<any>>(
      `${environment.apiUrl}/PreRegistration/AddQuestionRule`,
      data,
      { headers: this.headers }
    );
  }

  public editQuestionRule(data: any) {
    this.dataService.formEdited.push(data.FormId);
    return this.http.post<CommonAPIResponse<any>>(
      `${environment.apiUrl}/PreRegistration/EditQuestionRule`,
      data,
      { headers: this.headers }
    );
  }

  public deleteQuestionRule(questionRuleId: number) {
    return this.http.delete<CommonAPIResponse<any>>(
      `${environment.apiUrl}/PreRegistration/DeleteQuestionRule?Id=${questionRuleId}`
    );
  }

  public getQuestionEquationRules(FormId: number) {
    return this.http.get<CommonAPIResponse<any>>(
      `${environment.apiUrl}/PreRegistration/GetQuestionEquationRules?FormId=${FormId}`,
      { responseType: 'json' }
    );
  }

  public getRelationships() {
    return this.http.get<CommonAPIResponse<any>>(
      `${environment.apiUrl}/Bhakt/GetFamilyRelationType`,
      { responseType: 'json' }
    );
  }

  public addQuestionEquationRule(data: any) {
    this.dataService.formEdited.push(data.FormId);
    return this.http.post<CommonAPIResponse<any>>(
      `${environment.apiUrl}/PreRegistration/AddQuestionEquationRule`,
      data,
      { headers: this.headers }
    );
  }

  public editQuestionEquationRule(data: any) {
    this.dataService.formEdited.push(data.FormId);
    return this.http.post<CommonAPIResponse<any>>(
      `${environment.apiUrl}/PreRegistration/EditQuestionEquationRule`,
      data,
      { headers: this.headers }
    );
  }

  public deleteQuestionEquationRule(questionEquationRuleId: number) {
    return this.http.delete<CommonAPIResponse<any>>(
      `${environment.apiUrl}/PreRegistration/DeleteQuestionEquationRule?Id=${questionEquationRuleId}`
    );
  }

  public updateTxnStatus(id: string, status: string) {
    return this.http.put<CommonAPIResponse>(
      `${environment.apiUrl}/Transaction/Payment/UpdateTransactionStatus?transactionId=${id}&status=${status}`,
      {}
    );
  }

  public secondBhaktLogin(data) {
    return this.http.post<any>(
      `${environment.apiUrl}/Authenticate/SecondBhaktLogin`,
      data
    );
  }

  public getShareLink(formId: number) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http.post<any>(
      `${environment.apiUrl}/Authenticate/GetEncryptedString?input=${formId}`,
      {},
      { headers, responseType: 'text' as 'json' }
    );
  }

  public getPavti(transactionReferenceNumber: number) {
    return this.http.get<any>(
      `${environment.apiUrl}/Transaction/GetPavti?trn=${transactionReferenceNumber}`,
      {
        responseType: 'blob' as 'json',
      }
    );
  }

  public setEventDetails() {
    const EventId = 7;
    return this.http.get(
      `${environment.bhajanYagApiUrl}/GetEventRegistrationInfo/${EventId}`
    );
  }

  public getYagnaSeatAllocation(){
    return this.http.get<CommonAPIResponse<any>>(
      `${environment.apiUrl}/PreRegistration/GetYagnaSeatAllocation`,
      { headers: this.headers }
    );
  }

  public getYagnaPdf(formId: number, bhaktIds: number[]) {
    const bhaktIdsParam = bhaktIds.map(id => `bhaktIds=${id}`).join('&');
    return this.http.get<any>(
      `${environment.apiUrl}/PreRegistration/GetYagnaFormResponsePDF?formId=${formId}&${bhaktIdsParam}`,
      {
        responseType: 'blob' as 'json',
      }
    );
  }

  public GetUserPermissions() {
    return this.http.get<CommonAPIResponse<any>>(
      `${environment.apiUrl}/PreRegistration/GetUserPermissions`,
      { headers: this.headers }
    );
  }

  public uploadFormImage(formData: FormData) {
    return this.http.post<CommonAPIResponse<any>>(
      `${environment.apiUrl}/PreRegistration/UploadFormImage`,
      formData
    );
  }

  public deleteFormImage(imageId: number) {
    return this.http.post<CommonAPIResponse<any>>(
      `${environment.apiUrl}/PreRegistration/DeleteFormImage`,
      { ImageId: imageId },
      { headers: this.headers }
    );
  }

  public getFormImages(formId: number) {
    return this.http.get<CommonAPIResponse<any>>(
      `${environment.apiUrl}/PreRegistration/GetFormImages?FormId=${formId}`,
      { headers: this.headers }
    );
  }

  public getFormImageByName(formId: number, imageName: string) {
    return this.http.get<CommonAPIResponse<any>>(
      `${environment.apiUrl}/PreRegistration/GetFormImage?FormId=${formId}&ImageName=${encodeURIComponent(imageName)}`,
      { headers: this.headers }
    );
  }

  
  /**
   * Returns image as Blob. API responds with JSON: Code, Message, Data.ImageContent (base64).
   */
  public getFormImage(FormId: number, ImageName: string) {
    return this.http
      .get<CommonAPIResponse<any>>(
        `${environment.apiUrl}/PreRegistration/GetFormImage?FormId=${FormId}&ImageName=${encodeURIComponent(ImageName)}`,
        { responseType: 'json' }
      )
      .pipe(
        map((res) => {
          if (res?.Code !== 0 || !res?.Data?.ImageContent) {
            throw new Error(res?.Message || 'Image not found');
          }
          return this.base64ImageContentToBlob(res.Data.ImageContent);
        })
      );
  }

  private base64ImageContentToBlob(imageContent: string): Blob {
    let b64 = String(imageContent).trim();
    let mime = 'image/png';
    const dataUrl = /^data:([^;]+);base64,/i.exec(b64);
    if (dataUrl) {
      mime = dataUrl[1] || mime;
      b64 = b64.substring(b64.indexOf(',') + 1);
    }
    const binary = atob(b64);
    const len = binary.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binary.charCodeAt(i);
    }
    return new Blob([bytes], { type: mime });
  }

  /**
   * Present city/village autocomplete via {@link environment.apiUrl}/Bhakt/CityVillageList.
   */
  public searchPresentVillagePlaces(
    query: string
  ): Observable<PresentVillageSearchItem[]> {
    const q = query.trim();
    if (q.length < 3) {
      return of([]);
    }
    return this.http
      .get<PresentVillageSearchItem[]>(`${environment.apiUrl}/Bhakt/CityVillageList`, {
        params: new HttpParams().set('searchText', q),
        headers: this.headers,
      })
      .pipe(catchError(() => of([])));
  }
}
